var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6987 31.8703L9.24283 6.41448C8.46178 5.63344 7.19545 5.63344 6.4144 6.41448C5.63335 7.19553 5.63335 8.46186 6.4144 9.24291L31.8702 34.6988C32.6513 35.4798 33.9176 35.4798 34.6987 34.6988C35.4797 33.9177 35.4797 32.6514 34.6987 31.8703Z",
    fill: "#2A374E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8705 6.41421L6.4147 31.8701C5.63365 32.6511 5.63365 33.9174 6.4147 34.6985C7.19575 35.4795 8.46208 35.4795 9.24313 34.6985L34.699 9.24264C35.48 8.46159 35.48 7.19526 34.699 6.41421C33.9179 5.63317 32.6516 5.63317 31.8705 6.41421Z",
    fill: "#2A374E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.b9679d2218efc494edff2ccde9cd8549.svg";
export { ForwardRef as ReactComponent };